<template>
  <div @click.once="navigate" class="navigate-user-wrapper">
    <img src="@/assets/back-arrow.png" />
    <h2>{{ $t("message.continueOrdering") }}</h2>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["currentStoreDoc"]),
  },
  methods: {
    navigate() {
      this.$router.push({
        name: "store",
        params: {
          storename: this.currentStoreDoc.Name,
          storeid: this.currentStoreDoc.ID,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navigate-user-wrapper {
  display: flex;
  align-items: baseline;
  &:hover {
    cursor: pointer;
  }
  img {
    margin-right: 5px;
  }
}
</style>
